export default () => ({
  logEvent: () => Promise.resolve(),
  logScreenView: () => Promise.resolve(),
});
